import { render, staticRenderFns } from "./UserActionsForm.vue?vue&type=template&id=88283794&"
import script from "./UserActionsForm.vue?vue&type=script&lang=js&"
export * from "./UserActionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports